'use client'

export default function Error({ reset }: { reset: () => void }) {
	return (
		<div>
			<h2>Oh no!</h2>
			<p className="my-2">There was an issue with our website. This could be a temporary issue, please try again.</p>
			<button onClick={() => reset()}>Try Again</button>
		</div>
	)
}
